@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

@delegate:ResourceContentHash(-888_171_563)
internal val Res.drawable.google_logo_dark: DrawableResource by lazy {
      DrawableResource("drawable:google_logo_dark", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/google-logo-dark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_418_413_491)
internal val Res.drawable.google_logo_light: DrawableResource by lazy {
      DrawableResource("drawable:google_logo_light", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/google-logo-light.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_820_206_858)
internal val Res.drawable.preview: DrawableResource by lazy {
      DrawableResource("drawable:preview", setOf(
        ResourceItem(setOf(), "${MD}drawable/preview.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_717_986_336)
internal val Res.drawable.strike_radar_logo: DrawableResource by lazy {
      DrawableResource("drawable:strike_radar_logo", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/strike_radar_logo.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/strike_radar_logo.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("google_logo_dark", Res.drawable.google_logo_dark)
  map.put("google_logo_light", Res.drawable.google_logo_light)
  map.put("preview", Res.drawable.preview)
  map.put("strike_radar_logo", Res.drawable.strike_radar_logo)
}
